import styled from 'styled-components';

import {useToast} from "@chakra-ui/react";
import {Delete} from "lucide-react";
import React from "react";
import useFeedback from "../../utils/use_feedback";
import {useBlock} from "../../api/user";
import {useStoreProfile} from "../../store";
import {FixedTopBar} from "../../components/top_bar";
import {WhiteMain} from "../../components/main";

const User = styled.div``;
const Unblock = styled.div``;
const BlockHelp = styled.div`
  margin-top: 32px;
  text-align: center;
h2 {
  font-weight: 500;
}
p {
  margin: 12px 32px;
}`;
const BlockList = styled(({blocked, className}) => {
    const {feedbackCh} = useFeedback(true);
    const block = useBlock(feedbackCh);
    const toast = useToast();
    const handleBlock = async (user) => {
        try {
            await block(user);
            toast({
                title: `Unblocked user!`,
                status: 'success',
                isClosable: true,
            });
        } catch {
            toast({
                title: `Failed to unblock.`,
                status: 'error',
                isClosable: true,
            });
        }
    };
    return (
        <div className={className}>
            {blocked?.map((user) =>
                <User key={user}>
                    {user}
                    <Unblock onClick={() => handleBlock(user)}>
                        <Delete size={20} />
                    </Unblock>
                </User>
            )}
        </div>
    );
})`
  color: ${({theme}) => theme.menu.color};
  ${User} {
    display: flex;
    padding: 12px 20px;
    font-size: 15px;
  }
  ${Unblock} {
    margin-left: auto;
    padding: 0 8px;
  }
`;

const Blocks = ({className}) => {
    const {blocked} = useStoreProfile();
    return (
        <>
            <FixedTopBar back title="Blocked Users" border/>
            <WhiteMain className={className}>
                {(blocked && blocked.length > 0) ?
                    <BlockList blocked={blocked} />
                    :
                    <BlockHelp>
                        <h2>
                            You haven't blocked anyone.
                        </h2>
                        <p>
                            If you want to block a user, you can tap the three dots alongside any of their posts or comments to find the block option.
                        </p>
                    </BlockHelp>
                }
            </WhiteMain>
        </>
    );
};

export default Blocks;
